(() => {
  const selector = 'img[data-hostecco-srcset]';

  const loadFullImage = (image) => {
    if (!image?.dataset.hosteccoSrcset) return;
    image.srcset = image.dataset.hosteccoSrcset;
    image.src = image.dataset.hosteccoSrc;
    image.removeAttribute('data-hostecco-srcset');
    image.removeAttribute('data-hostecco-src');
  };

  const deferredImages = [...document.querySelectorAll(selector)];
  if (!deferredImages.length) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadFullImage(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '250px 0px' }
    );
    deferredImages.forEach((image) => observer.observe(image));
  } else {
    deferredImages.forEach(loadFullImage);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.thumbnail-list button');
    if (!button) return;
    const buttons = [...document.querySelectorAll('.thumbnail-list button')];
    const galleryImages = [...document.querySelectorAll('.product__media-list img')];
    loadFullImage(galleryImages[buttons.indexOf(button)]);
  });
})();
